import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getAnalyticsConsent, setAnalyticsConsent } from '../utils/ga4';

export default function AnalyticsConsentBanner() {
  const [visible, setVisible] = useState(() => getAnalyticsConsent() === null);

  const choose = (consent: 'granted' | 'denied') => {
    setAnalyticsConsent(consent);
    setVisible(false);
  };

  if (!visible) {
    return (
      <button
        className="fixed bottom-3 left-3 z-[100] rounded border bg-white px-3 py-2 text-xs shadow"
        onClick={() => setVisible(true)}
      >
        Analytics preferences
      </button>
    );
  }

  return (
    <aside
      aria-label="Analytics consent"
      className="fixed inset-x-4 bottom-4 z-[100] mx-auto max-w-3xl rounded-lg border bg-white p-4 shadow-xl"
    >
      <p className="text-sm text-gray-700">
        We use optional analytics to understand registration and improve Practice Studio. No names,
        email addresses, or practice details are sent. See our{' '}
        <Link className="underline" to="/privacy-policy">Privacy Policy</Link>.
      </p>
      <div className="mt-3 flex justify-end gap-2">
        <button className="rounded border px-4 py-2 text-sm" onClick={() => choose('denied')}>
          {getAnalyticsConsent() === 'granted' ? 'Withdraw consent' : 'Decline'}
        </button>
        <button
          className="rounded bg-blue-600 px-4 py-2 text-sm text-white"
          onClick={() => choose('granted')}
        >
          Allow analytics
        </button>
      </div>
    </aside>
  );
}
